const licenceExpiresAtValueGetter = (params) => {
  return params.data.licence_expires_at;
};

export default {
  licenceExpiresAtValueGetter
};